import mapboxgl from 'mapbox-gl';
mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

export const MapboxStyleDefinition = [
    {
        title: 'Standard Karte',
        uri: 'mapbox://styles/nebuto/clud397ey006l01nt52370mpd',
    },
    {
        title: 'Nacht Karte',
        uri: 'mapbox://styles/nebuto/clqwisijr010n01qu6e5s3hhj',
    },
    {
        title: 'Satellitenkarte',
        uri: 'mapbox://styles/nebuto/cl7oqd0r8000014q2kbou2i0u',
    },
];

export const mapboxOptions = {
    defaultStyle: 'Standard Karte',
};

export const getMap = (ref) => {
    const map = new mapboxgl.Map({
        displayControlsDefault: false,
        container: ref?.current,
        style: 'mapbox://styles/nebuto/clud397ey006l01nt52370mpd',
        center: [9, 51],
        zoom: 13,
        animate: false,
    });


    return map;
};


